/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_ApproveInputs */

const en_admin_registration_approve = /** @type {(inputs: Admin_Registration_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const de_admin_registration_approve = /** @type {(inputs: Admin_Registration_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigen`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Admin_Registration_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_approve = /** @type {((inputs?: Admin_Registration_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_approve(inputs)
	return en_admin_registration_approve(inputs)
});